import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import Header from "../components/Header";

function HourlyService() {
  return (
    <>
    <section 
      className="relative w-full min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] bg-cover bg-center"
      style={{
        backgroundImage: "url('blog12.png')",
      }}
    >
      <Header/>

      {/* Hero Content */}
      <div className="relative z-20 flex items-center justify-center min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] px-4">
        <div className="max-w-5xl text-center text-white">
          <h1 className="font-bold leading-snug text-white">
            Hourly Limo Rental in NYC
          </h1>
          <div className="mt-6 flex justify-center gap-2 text-sm font-medium">
            <a href="/" className="hover:text-logo-green">Home</a>
            <span>-</span>
            <span className="text-logo-green">Hourly Service</span>
          </div>
        </div>
      </div>
    </section>

       <section className="bg-white py-10 sm:py-10 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="Hourly Limo Rental in NYC Majestic Voyage USA" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Book Luxury Limo Service by the Hour in New York City
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Travel around New York City with complete comfort and flexibility by choosing Hourly Limo Rental 
          from Majestic Voyage USA. Our hourly limo service is designed for clients who want premium 
          transportation without being restricted to fixed routes or full-day bookings.
        </p>
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Whether you need a limo for business meetings, errands, shopping, sightseeing, or special occasions, 
          we provide a smooth and luxurious experience every time. Our fleet offers spacious interiors, 
          climate-controlled cabins, and modern amenities that ensure a relaxing ride while our professional 
          chauffeurs take care of the driving.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          How Much Does a Limo Cost Per Hour with Majestic Voyage Limo Transportation Service?
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          The cost of a limo per hour with Majestic Voyage Limo Transportation Service depends on the vehicle 
          type, duration, and time of booking. Hourly limo rates in New York City typically vary based on 
          luxury level and passenger capacity.
        </p>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Our pricing is transparent and includes a professional chauffeur, fuel, and flexible hourly usage. 
          Longer bookings often offer better value per hour. Contact Majestic Voyage for a customized quote 
          tailored to your NYC travel needs.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="Limo Rates Per Hour NYC" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="Limo Rates Per Hour with Majestic Voyage Limo NYC" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Limo Rates Per Hour with Majestic Voyage Limo NYC
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Our limo rates per hour with Majestic Voyage Limo NYC start competitively based on vehicle type 
          and service level. Hourly pricing varies depending on the limo model, time of day, and total 
          hours booked.
        </p>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          All rates include a professional chauffeur, fuel, and flexible stops throughout New York City. We 
          offer transparent pricing with no hidden fees and personalized quotes for your trip. Contact us 
          today to get your customized hourly limo rate in NYC.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          How Our Hourly Limo Service Works
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Booking an hourly limo with us is simple and stress-free:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2"><strong>1.</strong></span>
            <span><strong>Share Your Travel Details:</strong> Tell us your pickup location, preferred vehicle, and the number of hours you need the limo.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2"><strong>2.</strong></span>
            <span><strong>Select Your Luxury Vehicle:</strong> Choose from our premium sedans, SUVs, and stretch limousines based on your comfort and group size.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2"><strong>3.</strong></span>
            <span><strong>Confirm Your Booking:</strong> Receive a clear hourly quote with no hidden charges and confirm your reservation.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2"><strong>4.</strong></span>
            <span><strong>Enjoy Your Ride:</strong> Our professional chauffeur arrives on time and stays with you for the entire booked duration.</span>
          </li>
        </ul>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="How Our Hourly Limo Service Works" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="What's Included in Our Hourly Limo Rentals" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          What's Included in Our Hourly Limo Rentals
        </h2>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">✔️</span>
            <span>Experienced and courteous chauffeurs</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">✔️</span>
            <span>Well-maintained luxury vehicles</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">✔️</span>
            <span>Flexible hourly booking options</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">✔️</span>
            <span>Real-time GPS navigation for timely arrivals</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">✔️</span>
            <span>Comfortable, spacious, and stylish interiors</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">✔️</span>
            <span>Personalized service based on your itinerary</span>
          </li>
        </ul>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Why Choose Hourly Limo Rental in NYC?
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Hourly limo service is the perfect solution when you need flexibility and luxury combined.
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Pay only for the time you use</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Make multiple stops without extra hassle</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Ideal for business travel, city tours, and events</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Enjoy premium comfort and privacy</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>No rush travel at your own pace</span>
          </li>
        </ul>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Whether you're attending meetings in Manhattan, shopping across the city, or planning a special 
          day out, our hourly limo rental gives you complete control over your schedule.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="Why Choose Hourly Limo Rental in NYC" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="Book Your Hourly Limo in New York City Today" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Book Your Hourly Limo in New York City Today
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Experience first-class transportation with Majestic Voyage USA. Our hourly limo rental service 
          delivers luxury, reliability, and flexibility tailored to your needs.
        </p>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Contact us today to reserve your ride and travel NYC in style and comfort.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
    
    <FAQ/>

    <Footer/>
    </>
  );
}

export default HourlyService;
